package com.appcreator.blueprint.firebase.auth

import com.appcreator.blueprint.core.Action
import com.appcreator.blueprint.core.ActionClass
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("FirebaseAuthSignInWithApple")
@ActionClass(
    group = FirebaseAuthConsts.group,
    title = "Sign in with Apple",
    isExtraPlugin = true,
    availableFrom = "0.0.1"
)
class FirebaseAuthSignInWithApple: Action
